module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-bierkul-tour"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_c('small', [_vm._v("Ein Fest ist ein Fest.")]), _vm._v("\n            Oder ein Zissel!\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Die Brauereibesichtigungen bei Zissel")]), _vm._v(" "), _c('p', [_vm._v("erfreuen sich in den letzten Jahren immer größerer Beliebtheit.")]), _vm._v(" "), _c('p', [_vm._v("Immer freitags und samstags können Sie hinter"), _c('br'), _vm._v("\n                        die Kulissen der Zissel-Braukunst blicken.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-6"
  }, [_c('p', [_vm._v("\n                        Wir laden Sie ein, in unserer Privatbrauerei die Herstellung unserer Biere kennenzulernen.\n                        Dabei werden Sie sowohl mit unseren Rohstoffen als auch mit dem modernen Stand der\n                        Brautechnik vertraut gemacht. Selbstverständlich können Sie während des Rundgangs unsere\n                        verschiedenen Biere verkosten. Ein bieriges Erlebnis erwartet Sie!\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "infobox"
  }, [_c('h3', [_vm._v("Führungen nach telefonischer Anmeldung:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("freitags 16.00 Uhr ")]), _vm._v(" "), _c('li', [_vm._v("samstags 16.00 Uhr")]), _vm._v(" "), _c('li', [_vm._v("Kosten für Führung inklusive Bier und Brauervesper: 15 Euro pro Teilnehmer.")]), _vm._v(" "), _c('li', [_vm._v("Führungen mit unserem Braumeister und spezielle Arrangements sind ebenfalls möglich.")])]), _vm._v(" "), _c('p', [_vm._v("\n                            Buchungen "), _c('a', {
    attrs: {
      "href": "mailto:#0"
    }
  }, [_vm._v("hier per E-Mail")]), _vm._v(" oder bei"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Peter Gröger, Telefon (0 92 14) 13 24 53")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col sm-6"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-2.jpg",
      "alt": "Brauereiführung"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b30abca0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/bierkul-tour.vue
// module id = 33
// module chunks = 0